import { createRouter, createWebHistory } from 'vue-router';

// User registration pages
import Register from '@/views/Register/RegisterView.vue';
import Login from '@/views/login/LoginView.vue';
import Reset from '@/views/Reset/ResetView.vue';

// Navigation Pages
import Home from '@/views/Home/HomeView.vue';
import Create from '@/views/Create/CreateView.vue';
import Drive from '@/views/Drive/DriveView.vue';
import Settings from '@/views/Settings/SettingsView.vue';
import Chat from '@/views/Chat/OneChatView.vue';
import FirstTimeLogin from '@/views/FirstTimeLogin/FirstTimeLogin.vue';
import ResetSent from '@/views/ResetPasswordSent/ResetSent.vue';
import ResetLinkSent from '@/views/ResetLinkSent/ResetLinkSent.vue';
import AuditTrail from '@/views/AuditTrail/AuditTrailView.vue';
import OneTimePassword from '@/views/OneTimePassword/OneTimePassword.vue';
import MainSettings from '@/views/MainSettings/MainSettings.vue';
import ProfileView from '@/views/Profile/ProfileView.vue';
import PermissionView from '@/views/Permission/PermissionVIew.vue';
import RoleView from '@/views/Role/RoleView.vue';
import RolePermissionsView from '@/views/RolePermissions/RolePermissionsView.vue';
import AccessControlView from '@/views/AccessControl/AccessControlView.vue';
import IndividualDashboard from '@/views/IndividualDashboard/IndividualDashboard.vue'
import SystemConfigureView from '@/views/System_Configure/SystemConfigureView.vue';
import UserPermissionsView from '@/views/UserPermissions/UserPermissionsView.vue';
import SupersetManager from '@/views/SupersetManager/SupersetManager.vue';

const routes = [
  {
    path: '/register',
    name: 'Register',
    component: Register
  },

  {
    path: '/',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('token');
      if (token) {
        next({ name: 'IndividualDashboard' });
        return;
      }
      next();
    }
  },

  {
    path: '/reset',
    name: 'Reset',
    component: Reset
  },

  {
    path: '/home_v1',
    name: 'Home',
    component: Home
  },
  {
    path: '/create',
    name: 'Create',
    component: Create
  },
  {
    path: '/drive',
    name: 'Drive',
    component: Drive
  },
    {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat
  },
  {
    path: '/first_time_login',
    name: 'FirstTimeLogin',
    component: FirstTimeLogin
  },
  {
    path: "/reset_password_sent/:uidb64/:token",
    name: "ResetPasswordSent",
    component: ResetSent,
    props: true,
    meta: { requires_auth: false }, // No authentication required for reset password sent
  },
  {
  path: '/reset_link_sent',
  name: 'ResetLinkSent',
  component: ResetLinkSent,
  meta: { requires_auth: false },
  },
  {
    path: '/audit_trail',
    name: 'AuditTrail',
    component: AuditTrail
  },

  {
    path: '/otp',
    name: 'OneTimePassword',
    component: OneTimePassword
  },
  {
    path: '/main_settings',
    name: 'MainSettings',
    component: MainSettings
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView
  },
  {
    path: '/permission',
    name: 'Permission',
    component: PermissionView
  },
  {
    path: '/role',
    name: 'Role',
    component: RoleView
  },
  {
    path: '/role_permissions/:id',
    name: 'RolePermissions',
    component: RolePermissionsView
  },
  {
    path: '/access_control',
    name: 'AccessControl',
    component: AccessControlView
  },
  {
    path: '/home',
    name: 'IndividualDashboard',
    component: IndividualDashboard
  },
  {
    path: '/system_configure',
    name: 'SystemConfigure',
    component: SystemConfigureView
  },
  {
    path: '/user_permissions/:user_id',
    name:'UserPermissions',
    component: UserPermissionsView,
  },
  {
    path: '/superset_manager',
    name: 'SupersetManager',
    component: SupersetManager
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes
})



export function set_auth(token, user_id) {
  localStorage.setItem('token', token);
  localStorage.setItem('user_id', user_id);
}


export function set_drive_id(drive_id) {
  if (drive_id) {
    localStorage.setItem('drive_id', drive_id);
  }
}


export function get_drive_id() {
  return localStorage.getItem('drive_id');
}



export function set_user_details(user_details) {
  if (user_details) {
    localStorage.setItem('role', user_details.role || '');
    localStorage.setItem('first_name', user_details.first_name || '');
    localStorage.setItem('last_name', user_details.last_name || '');
    localStorage.setItem('email', user_details.email || '');
    localStorage.setItem('client_type', user_details.client_type || '');
    localStorage.setItem('company_id', user_details.company_id || '');


  }
}


export function get_user_details() {

  const user_role = localStorage.getItem('role');
  const first_name = localStorage.getItem('first_name');
  const last_name = localStorage.getItem('last_name');
  const email = localStorage.getItem('email');
  const client_type = localStorage.getItem('client_type');
  const company_id = localStorage.getItem('company_id');


  var user_details = {
    "role":user_role,
    "first_name":first_name,
    "last_name":last_name,
    "email":email,
    "client_type":client_type,
    "company_id":company_id

  }


  return user_details;
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

export function clear_auth_state() {
  [
    'token', 'user_id', 'role', 'first_name', 'last_name', 'email',
    'client_type', 'company_id', 'drive_id', 'otp_required', 'otp_verified'
  ].forEach((k) => localStorage.removeItem(k));
}

function is_demo_domain() {
  return window.location.hostname.includes("demo.live.aic-one.com");
}


export function get_token() {
  const token = localStorage.getItem('token');

  if (!token) {
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('email');
    localStorage.removeItem('client_type');
    localStorage.removeItem('otp_required');
    localStorage.removeItem('otp_verified');
    localStorage.removeItem('company_id');
    localStorage.removeItem('drive_id');
    return null;
  }
  return token;
}

const protected_routes = ['/home', '/drive', '/chat', '/settings', '/audit_trail'];

const allowed_sso_apps = [
  'complyon',
  'orcaa',
  'proba',
  'xverdict',
  'engagenet',
  'proba_workflow'
];

router.beforeEach((to) => {
  if (to.query.next && allowed_sso_apps.includes(to.query.next)) {
    if (!localStorage.getItem('sso_next')) {
      localStorage.setItem('sso_next', to.query.next);
    }
    return { path: to.path, query: {} };
  }

  if (is_demo_domain() && to.path === '/') {
    return '/create';
  }

  const token = get_token();
  const is_protected = protected_routes.includes(to.path);
  const otp_required = localStorage.getItem('otp_required') === '1';
  const otp_verified = localStorage.getItem('otp_verified') === '1';

  const is_public = (
    to.path === '/' ||
    to.path === '/register' ||
    to.path === '/reset' ||
    to.name === 'ResetPasswordSent' ||
    to.name === 'ResetLinkSent'
  );

  if (to.path === '/create') {
    if (is_demo_domain()) {
      return true;
    }
    if (!token) return { name: 'Login' };
  }

  if (!token && is_protected) {
    return { name: 'Login' };
  }

  if (otp_required && !otp_verified && !is_public && to.path !== '/otp') {
    return { name: 'OneTimePassword', query: { next: to.fullPath } };
  }

  return true;
});



export function get_user_id() {
  return localStorage.getItem('user_id');
}

export default router
